import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create Class
export const createSubCategory = data => post(url.CREATE_SUBCATEGORY, data);
export const updateSubCategory = data => put(url.UPDATE_SUBCATEGORY, data);
export const deleteSubCategory = id => del(url.DELETE_SUBCATEGORY + id);
export const fetchAllSubCategory = () => get(url.FETCH_ALL_SUBCATEGORY);
export const fetchAllSubCategoryBasedOnCategory = data => post(url.GET_ALL_SUBCATEGORY_BASED_ON_CATEGORY, data);